<template>
  <iframe :class="previewClass" :src="previewData.preview_path" frameborder="0"></iframe>
</template>

<script>
export default {
  name: "officePreview",
  data() {
    return {};
  },
  created() {
    // console.log("初始化officePreview预览组件");
  },
  computed: {
    previewData() {
      return this.$store.state.drive.previewData;
    },
    previewClass() {
      return "preview-" + this.previewData.position;
    }
  },
  destroyed() {
    // console.log("销毁officePreview预览组件");
    this.$store.commit("setPreviewData", {
      preview_path: "",
      previewer: "unknowPreview"
    });
  }
};
</script>

<style scoped>
.preview-fullscreen {
  width: 100%;
  height: 100%;
}
.preview-fullscreen-top {
  width: 100%;
  height: 100%;
}
.preview-inside {
  width: 460px;
  height: 280px;
}
</style>